import React, { Component } from "react";

import Image from "../../../../components/image";
import Link from "../../../../components/link";
import Modal from "../../components/modal";
import Icon from "../../../../components/icon/icon";
import ServicesModal from "src/modules/package/components/servicesModal";

import { addLodgingToCart } from "../../../../services/lodging";
import { toCurrency } from "../../../../utils/currency";
import { getLanguageField } from "../../../../utils/language";
import provisionalModuleDataBasedOnLanguage from "../../searchList/provisionalModuleDataBasedOnLanguage";
import { gtmFunction } from "../../../../utils/gtm";
import { toYYYYMMDD } from "../../../../utils/datefns";
import UpsellingModal from "src/components/upselling/upsellingModal";

export default class ActivityCell extends Component {
  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();
    this.divRef = React.createRef();
  }

  state = {
    selectedPrice: false,
    loadingAdd: false,
    modalAddToCart: false,
    showPrices: false,
    showAllDescription: false,
    hideShowMore: false,
    showMobileDescription: false
  }

  componentDidMount() {
    const buttonRect = this.buttonRef.current.getBoundingClientRect();
    const divRect = this.divRef.current.getBoundingClientRect();

    const relativeTop = buttonRect.top - divRect.top;

    if(relativeTop < 100) {
      this.setState({hideShowMore: true});
    }
  }

  componentDidUpdate(prevProps) {
    if ((this.props.unit.price && !this.state.selectedPrice )|| (this.props.unit.price !== prevProps.unit.price) ){
      const lowestPrice = this.props.unit.price.reduce((minPrice, currentPrice) => {
        if (currentPrice.amount < minPrice.amount) {
          return currentPrice;
        } else {
          return minPrice;
        }
      });
      this.setState({ selectedPrice: lowestPrice, showPrices: this.props.unit.price.length === 1 });
    }
  }

  handleChangePrice = (event) => {
    const foundPrice = this.props.unit.price.find(price =>  price.id === parseInt(event.target.value));
    this.setState({ selectedPrice: foundPrice })
  };

  addProductToCart = ({ price, guests, range, idx, complementary_products }) => {
    this.setState({ loadingAdd: idx })
    addLodgingToCart({ product: { ...this.props.unit, supplier_uuid: this.props.supplier.supplier_uuid }, price, form: { guests, range }, type: "activity", complementary_products })
    .catch(() => this.setState({ loadingAdd: false }))
    .then((r) => {
      if (!r) {
        this.setState({ modalAddToCart: "error", loadingAdd: false })
      } else {
        this.setState({ loadingAdd: false, modalAddToCart: true })
      }
    })
  }

  togglePrices = () => {
    this.setState({ showPrices: !this.state.showPrices }, () => {
      if (this.state.showPrices) {
        gtmFunction("view_item", [{...this.props.unit, price: this.props.unit.price[0] }])
      }
    })
  }

  toggleShowMobileDescription = () => {
    this.setState({ showMobileDescription: !this.state.showMobileDescription });
  }

  toggleShowAllDescription = () => {
    this.setState({ showAllDescription: !this.state.showAllDescription });
  }

  render() {
    const { props, state, addProductToCart, togglePrices, toggleShowAllDescription, toggleShowMobileDescription } = this;
    const { unit, buttonStyle, supplier, language, secondaryButtonStyle } = props;
    const temporalTranslations = provisionalModuleDataBasedOnLanguage(language)
    const { loadingAdd, selectedPrice, showPrices } = state;

    const selectedServices = [];
    if (unit && unit.selected_services && unit.selected_services.length) {
      unit.selected_services.forEach((service) => {
        const groupName = getLanguageField(service.translations, language, "group_name");
        const individualName = getLanguageField(service.translations, language, "name");
        const serviceName = unit.selected_services.filter(serv => 
          getLanguageField(serv.translations, language, "group_name") === groupName && groupName.length).length > 1 
          ? groupName 
          : individualName;
          
        if (!selectedServices.find(serv => serv.serviceName === serviceName)) {
          selectedServices.push({ ...service, serviceName });
        }
      });
    }

    return (
      <div id={`${unit.type}-cell-${unit.uuid}`}>
        <div key={unit.uuid} className="flex flex-col sm:flex-row gap-3 lg:gap-4">
          {
            unit.images && unit.images[0] ?
            <div className="flex-shrink-0">
              <Image className={"object-cover hidden sm:block w-44 h-36 rounded-2xl sm:rounded-2xl overflow-hidden sm:w-60"} alt={unit.name} src={`https://public-assets.spotliodata.com/${unit.images[0].directus_files_id.filename_disk}`} />
            </div>
            : null
          }
          <div className="flex-1 flex sm:flex-col justify-between md:flex-row gap-2">
            <div ref={this.divRef} className="lg:w-3/4 flex flex-col gap-2">
              <h4 className="text-sm font-bold">
                {getLanguageField(unit.translations, language, "name")}
              </h4>
              {/* <p className="hidden lg:block text-sm text-gray-500">
                <TruncateText
                  buttonClassName={`inline-flex gap-1 items-center border-2 rounded-2xl py-1 px-4 w-fit mt-4 bg-white border-[color:var(--secondaryColor)] text-[color:var(--primaryColor)]`}
                  buttonClosedText={temporalTranslations.showMoreButtonLabel}
                  buttonOpenText={temporalTranslations.showLessButtonLabel}
                  text={getLanguageField(unit.translations, language, 'description', true)} 
                  characters={400}
                />
              </p> */}
              <div className={`hidden lg:block ${!this.state.showAllDescription ? 'max-h-16 overflow-hidden' : ''}`}>
                <p className="text-sm text-gray-500">{getLanguageField(unit.translations, language, 'description', true)}</p>
              </div>
              {
                !this.state.hideShowMore ? 
                <button
                  ref={this.buttonRef}
                  onClick={() => toggleShowAllDescription()}
                  className={`hidden lg:inline-flex gap-1 items-center border-2 rounded-xl py-1 px-4 mt-2 w-fit bg-white border-[color:var(--secondaryColor)] text-[color:var(--primaryColor)]`}
                >
                  {this.state.showAllDescription ? temporalTranslations.showLessButtonLabel : temporalTranslations.showMoreButtonLabel}
                </button>
                : null
              }
            </div>
            <div className="lg:w-1/4 flex flex-col items-end">
              {unit.price && unit.price.length > 1 ? <span className="text-[#75757D] text-sm">{temporalTranslations.from}</span> : null}
              <div className="flex flex-col text-xl semiboldFontFamily items-end mb-[10px]">
                {toCurrency({ value: selectedPrice?.amount, valueCurrency: selectedPrice?.currency})}
              </div>
              { unit.price ?
                <button onClick={() => togglePrices()} className="min-w-max mt-auto text-[color:var(--secondaryColor)] bg-[color:var(--primaryColor)] text-sm flex justify-center items-center gap-1 border py-2 px-3 rounded uppercase">
                  <span>{temporalTranslations[`view_${this.props.supplier.type}`]}</span>
                  <Icon icon={showPrices ? "ChevronUp": "ChevronDown"} />
                </button>
                : null
              }
            </div>
          </div>
          {
            supplier.upselling 
            ? 
            <UpsellingModal 
              closeFn={() => this.setState({ modalAddToCart: false })}
              open={this.state.modalAddToCart && this.state.modalAddToCart !== "error"}
              upselling={supplier.upselling} 
              language={language}
              addedProductName={getLanguageField(supplier.translations, language, 'name')}
            />
            :
            <Modal closeFn={() => this.setState({modalAddToCart: false})} open={this.state.modalAddToCart && this.state.modalAddToCart !== "error"} title={<Icon icon="CheckCircle" className="text-[#31AC0D]"/>} titleCentered>
              <div className="pb-6">
                <div className="text-center">
                  <span className="font-semibold">{getLanguageField(supplier.translations, language, 'name')}</span>
                  <span> {temporalTranslations.addedToCart}</span>
                </div>
                  <button className={`mt-4 w-full flex items-center justify-center border py-3 px-4 rounded-3xl font-semibold ${secondaryButtonStyle}`} onClick={() => this.setState({modalAddToCart: false})}>
                    {temporalTranslations.addMoreActivities}
                  </button>
                  <Link
                    href={temporalTranslations.linkToCart}
                    className={`mt-4 w-full flex items-center justify-end border py-3 px-4 rounded-3xl font-semibold ${buttonStyle}`}
                    onClick={() => this.setState({modalAddToCart: ""})}
                  >
                    <span className="mx-auto block">{temporalTranslations.goToCart}</span>
                  </Link>
              </div>
            </Modal>
          }
          <Modal
            alignedCenter
            closeFn={() => this.setState({ modalAddToCart: false })}
            open={this.state.modalAddToCart === "error"}
            title={<Icon icon="Info" className="text-red-500" />}
            titleCentered
            >
            <div className="text-center mb-8">
              {temporalTranslations.errorAdding}
            </div>
          </Modal>
        </div>
        { showPrices ?
          unit.price.sort((a, b) => { return a.amount - b.amount})
          .map((offer, idx) => {
            return (
              <ActivityRow
                addProductToCart={addProductToCart}
                loadingAdd={loadingAdd}
                offer={offer}
                unit={unit}
                temporalTranslations={temporalTranslations}
                idx={idx}
                buttonStyle={buttonStyle}
                date={this.props.date}
                showMobileDescription={this.state.showMobileDescription}
                toggleShowMobileDescription={toggleShowMobileDescription}
                language={language}
                loading={this.props.loading}
                selectedServices={selectedServices}
              />
            )
          })
          : null
        }
      </div>
    )
  }
}


class ActivityRow extends Component {
  state = {
    selectedGuests: "",
    selectedRange: false,
  }

  componentDidMount() {
    if (this.props.unit.availability && this.props.unit.availability.length) {
      this.setState({ selectedRange: this.props.unit.availability.length > 1 ? this.getFirstRangeAvailable(this.props.unit.availability) : this.props.unit.availability[0] });
    }

    if (this.props.unit.requirements?.length && this.state.selectedGuests === "") {
      this.setState({ selectedGuests: this.props.unit.requirements.find(req => req.key === "minPeople").value})
    } else if (!this.props.unit.requirements?.length && this.state.selectedGuests === "") {
      this.setState({ selectedGuests: 1 })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading && this.props.unit.availability?.length) {
      this.setState({ selectedRange: this.props.unit.availability.length > 1 ? this.getFirstRangeAvailable(this.props.unit.availability) : this.props.unit.availability[0] });
    }
  }

  checkIfSameDayPastHour = (hourRange) => {
    const isSameDay = toYYYYMMDD(this.props.date) === toYYYYMMDD(new Date())
    if (isSameDay && parseInt(hourRange.from_hour.split(":")[0]) <= new Date().getHours()) {
      return true;
    }
    return false;
  }
  
  handleChangeGuests = (event) => {
    this.setState({ selectedGuests: parseInt(event.target.value) })
  };

  handleChangeRange = (event) => {
    const foundAvailability = this.props.unit.availability.find(availability =>  availability.from_date === event.target.value);
    this.setState({ selectedRange: foundAvailability })
  };

  getFirstRangeAvailable = (availability) => {
    return availability.find(hourRange => {
      return !this.checkIfSameDayPastHour(hourRange)
    })
  }

  closeServicesModal = ({ product }) => {
    if(product){
      this.setState({ servicesModal: false, servicesModalProduct: product }, () => {
        this.props.addProductToCart({ price: this.props.offer,
          guests: this.state.selectedGuests,
          range: this.state.selectedRange,
          idx: this.props.idx,
          complementary_products: (this.state.servicesModalProduct.complementary_products || []).concat(this.props.unit.selected_services?.map(service => { return  {
            product_id: service.product_id,
            quantity: this.state.selectedGuests
          }}))
        });

      })
    }
    else {
      this.setState({servicesModal: false})
    }
  }

  checkForAddons = () => {
    if (this.props.unit.services && this.props.unit.services.length > 0) {
      this.openServicesModal({ 
        product: { 
          ...this.props.unit, services: this.props.unit.services?.map(
            service => { 
              return { 
                ...service, maxQuantity: service.max_quantity || this.state.selectedGuests, variable_quantity: service.max_quantity > 1 || this.state.selectedGuests > 1 
              }
            }
          ) 
        }
      })
    } else {
      this.props.addProductToCart({ 
        price: this.props.offer, 
        guests: this.state.selectedGuests, 
        range: this.state.selectedRange, 
        idx: this.props.idx, 
        complementary_products: this.props.unit.selected_services?.map(service => { return  {
          product_id: service.product_id,
          quantity: this.state.selectedGuests
        }})
      });
    }
  }

  openServicesModal = ({ product }) => {
    this.setState({ servicesModal: true, servicesModalProduct: product })
  }

  render() {
    const { props, state, handleChangeGuests, handleChangeRange } = this;
    const { offer, unit, temporalTranslations, idx, selectedServices, loadingAdd, buttonStyle } = props;
    const { selectedGuests, selectedRange } = state;
    const { showMobileDescription, toggleShowMobileDescription, language } = props;
    const borderClassname = idx + 1 !== unit.price?.length ? "border-b border-b-grey-500" : "";

    return (
      <React.Fragment>
        <div key={`product-${idx}`} className={`flex-col md:flex-row flex items-center gap-4 ${borderClassname} ${idx === 0 ? "border-t mt-2" : ""} py-2`}>
          <div className="mr-auto md:mr-0">
            <span>{offer.price_name}</span>
            {
              selectedServices && selectedServices.length ?
                <div className="flex gap-2 flex-wrap items-center">
                  {selectedServices.map((s, idx) => {
                    return <React.Fragment key={`selected-service-${idx}`}>
                      +
                      <div key={`selected-service-${idx}`} className="text-sm">{s.serviceName}</div>
                      {s.show_price ? <span>(+{toCurrency({ value: s.price.price_value, valueCurrency: s.price.currency })})</span> : null}
                    </React.Fragment>
                  })}
                </div>
              : null
            }
          </div>
          <div className="flex gap-2 mr-auto md:mr-0 md:ml-auto">
            {
              unit.requirements && unit.requirements[0] && unit.requirements[0].value !== unit.requirements[1].value ?
              <select className="min-w-40 rounded border-[#e5e7eb] pr-8" value={selectedGuests} onChange={handleChangeGuests}>
                <option value="" disabled selected>{temporalTranslations.participantsPlaceholder}</option>
                {Array.from({ length: unit.requirements.find(req => req.key === "maxPeople").value - unit.requirements.find(req => req.key === "minPeople").value + 1 }, (_, i) => unit.requirements.find(req => req.key === "minPeople").value + i).map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1} {temporalTranslations.personLabel}
                  </option>
                ))}
              </select>
              :
              null
            }
            {
              console.log("unit", unit)
            }
            {
              !unit.availability.length || !selectedRange || unit.availability.length === 1 && unit.availability[0].type.indexOf("hour") < 0 ? null :
              <select disabled={unit.availability.length === 1} className={`min-w-40 rounded border-[#e5e7eb] pr-8`} value={selectedRange.from_date} onChange={handleChangeRange}>
                <option disabled value="">{temporalTranslations.timePlaceholder}</option>
                {
                  unit.availability?.map((hourRange) => {
                    return (
                      <option disabled={this.checkIfSameDayPastHour(hourRange)} key={hourRange} value={hourRange.from_date}>
                        {`${hourRange.from_hour} - ${hourRange.to_hour}`}
                      </option>
                    )
                  }
                )}
              </select>
            }
          </div>
          <span className="w-full sm:w-24 text-right ml-auto md:ml-0">{toCurrency({ value: offer.type === "price_per_person" && typeof selectedGuests === "number" ? offer.amount * selectedGuests : offer.amount, valueCurrency: offer.currency})}</span>
          <button
            onClick={() => this.checkForAddons()}
            className={`w-full md:w-auto min-w-max text-sm flex justify-center items-center gap-1 border py-2.5 px-3 rounded ${loadingAdd === false ? buttonStyle : ""}`}
            disabled={loadingAdd !== false}
          >
            <span>{loadingAdd === idx ? temporalTranslations.addingToCart : temporalTranslations.addToCart}</span>
          </button>
          <div className="sm:hidden w-full">
            <button className={`w-full text-sm`} onClick={() => toggleShowMobileDescription()}>
              {showMobileDescription ? temporalTranslations.showLessButtonLabel : temporalTranslations.showMoreButtonLabel}
            </button>
            <div className={`w-full${showMobileDescription ? '' : ' hidden'}`}>
              <p className="text-sm text-gray-500">{getLanguageField(unit.translations, language, 'description', true)}</p>
            </div>
          </div>
        </div>
        {
          this.state.servicesModal ?
          <ServicesModal
            language={language}
            closeFn={this.closeServicesModal}
            product={this.state.servicesModalProduct}
            numberOfRooms={1}
            roomsTotal={1}
          />
          : null
        }
      </React.Fragment>
    )
  }
}